import Splide from '@splidejs/splide';

export default class ProductGallery extends HTMLElement {

    constructor() {
        super();
        this.mainCarousel = this.querySelector('.main-carousel');
        this.thumbnailsCarousel = this.querySelector('.thumbnails-carousel');
    }

    connectedCallback() {
        let main = new Splide( this.mainCarousel, {
            type      : 'slide',
            pagination: false,
            arrows    : true,
            heightRatio: 1
        });

        // Hauteur vignettes = largeur du carousel principal (ratio 1:1)
        const mainWidth = this.mainCarousel.offsetWidth;
        const thumbHeight = mainWidth > 0 ? mainWidth : 400;

        let thumbnails = new Splide( this.thumbnailsCarousel, {
            fixedWidth  : 84,
            fixedHeight : 84,
            gap         : 8,
            pagination  : false,
            arrows      : false,
            isNavigation: true,
            direction   : 'ttb',
            height      : thumbHeight,
            wheel       : true,
        });

        main.sync( thumbnails );
        main.mount();
        thumbnails.mount();
    }

}
